import React from 'react';
import { ChevronRight } from 'lucide-react';

/**
 * Renders a horizontal workflow — steps separated by → arrows.
 * Used across the brief on every product page.
 *
 *   <Workflow steps={['ASSET','CONDITION','PROJECT','EVIDENCE']} />
 */
const Workflow = ({ steps = [], variant = 'light', testid }) => {
  const isDark = variant === 'dark';
  return (
    <div
      className={`flex flex-wrap items-center gap-y-3 ${isDark ? 'text-slate-200' : 'text-slate-800'}`}
      data-testid={testid || 'workflow'}
    >
      {steps.map((s, i) => (
        <React.Fragment key={`${s}-${i}`}>
          <span
            className={`inline-flex items-center px-3 py-1.5 rounded-md text-[11px] uppercase tracking-[0.14em] font-semibold border ${
              isDark
                ? 'bg-slate-800/60 border-slate-700 text-slate-200'
                : 'bg-white border-slate-200 text-slate-700'
            }`}
          >
            {s}
          </span>
          {i < steps.length - 1 && (
            <ChevronRight
              className={`w-4 h-4 mx-1 ${isDark ? 'text-blue-400/70' : 'text-blue-500/80'}`}
              aria-hidden
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Workflow;
